// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ToggleButton_toggleButton__27ZYR","skinSelector":"ToggleButton_skinSelector__120dl"};